import script from "./ImpressumView.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpressumView.vue?vue&type=script&setup=true&lang=js"

import "./ImpressumView.vue?vue&type=style&index=0&id=6f3a9e6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f3a9e6b"]])

export default __exports__